import { render, staticRenderFns } from "./LazyLoadingTables.vue?vue&type=template&id=03592b5c"
import script from "./LazyLoadingTables.vue?vue&type=script&lang=js"
export * from "./LazyLoadingTables.vue?vue&type=script&lang=js"
import style0 from "./LazyLoadingTables.vue?vue&type=style&index=0&id=03592b5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports